// [sc-49299] Unità di vendita dell'articolo («Unità di vendita», `salesUnit`) e campi
// che servono per usarlo nel preventivo. Stesse regole e messaggi dell'API
// (utils/nuovoArticolo.js, validaVendita): a m² servono m² e pezzi per
// scatola, a metri lineari i metri per confezione, a scatola i pezzi per
// scatola; a pezzo e a confezione niente in più. Sempre: prezzo di listino.

import { getCategoryGroup } from "./categorieArticolo";

export const UNITA_VENDITA = [
  { value: "M2", label: "m²" },
  { value: "ML", label: "Metri lineari" },
  { value: "PZ", label: "Pezzo" },
  { value: "CONF", label: "Confezione" },
  { value: "SC", label: "Scatola" },
  // arrivano dai listini: si mostrano solo se l'articolo le ha già
  { value: "UD", label: "Unità (UD)" },
  { value: "KG", label: "Kg" },
  { value: "PAL", label: "Pallet" },
];

// Unità proposte per gruppo di categorie; la prima è quella di partenza
const PER_GRUPPO = {
  area: ["M2", "PZ", "CONF", "SC"],
  linear: ["ML", "PZ", "CONF"],
};
const ALTRE = ["PZ", "CONF"];

export const CAMPI_PER_UNITA = {
  M2: ["sqmPerBox", "piecesPerBox"],
  ML: ["mlPerBox"],
  SC: ["piecesPerBox"],
};

export const ETICHETTE_CAMPI = {
  sqmPerBox: "M² / scatola",
  piecesPerBox: "Pz / scatola",
  mlPerBox: "ML / confezione",
};

const vuoto = (v) => v === null || v === undefined || String(v).trim() === "";
const positivo = (v) => !vuoto(v) && Number(v) > 0;

/** Unità della tendina per la categoria; `attuale` resta anche se fuori elenco. */
export function unitaPerCategoria(category, attuale) {
  const codici = PER_GRUPPO[getCategoryGroup(category)] || ALTRE;
  const scelte = UNITA_VENDITA.filter((u) => codici.includes(u.value));
  const fuori = attuale && !codici.includes(attuale);
  if (fuori) {
    scelte.push(
      UNITA_VENDITA.find((u) => u.value === attuale) || {
        value: attuale,
        label: attuale,
      }
    );
  }
  return scelte;
}

/** Unità di partenza di un articolo nuovo. */
export function unitaIniziale(category) {
  return (PER_GRUPPO[getCategoryGroup(category)] || ALTRE)[0];
}

/**
 * Avviso se l'unità scelta non è quella abituale della categoria (per
 * esempio una piastrella a pezzo): si può, ma è insolito. null se è quella.
 */
export function avvisoUnita(category, salesUnit) {
  if (!salesUnit) return null;
  const abituale = unitaIniziale(category);
  if (salesUnit === abituale) return null;
  const etichetta = UNITA_VENDITA.find((u) => u.value === abituale)?.label;
  return `Unità insolita per «${category}»: di solito si vende a ${String(
    etichetta
  ).toLowerCase()}. Controlla che sia giusta.`;
}

/** Il campo è richiesto dall'unità di vendita? */
export function richiesto(salesUnit, campo) {
  return (CAMPI_PER_UNITA[salesUnit] || []).includes(campo);
}

/**
 * Errori dei campi di vendita, per campo. `completo` è falso se manca
 * qualcosa di obbligatorio: il bottone resta spento. Il messaggio compare
 * solo per un valore scritto ma non valido, non per un campo ancora vuoto.
 */
export function controlloVendita(form = {}) {
  const errori = {};
  let completo = true;
  const verifica = (campo, messaggio) => {
    if (positivo(form[campo])) return;
    completo = false;
    if (!vuoto(form[campo])) errori[campo] = messaggio;
  };
  verifica("price", "Inserisci un prezzo maggiore di 0.");
  if (vuoto(form.salesUnit)) completo = false;
  for (const campo of CAMPI_PER_UNITA[form.salesUnit] || []) {
    verifica(campo, "Inserisci un numero maggiore di 0.");
  }
  return { errori, completo };
}

/** Nome o brand: basta uno dei due (regola dell'API). */
export function haNomeOBrand(form = {}) {
  return !vuoto(form.itemName) || !vuoto(form.brand);
}
